import React, {Component} from 'react';
import {connect} from 'react-redux';

import DecorateContainer from '../../utils/DecoratedContainer';
import i18nLabels from './Footer.i18n';
import FooterMainView from './Footer.MainView';
import { getFooter } from '../../services/APIs/HeaderFooter';
import Utility from '../../utils/Helper';

const mapDispatchToProps = (dispatch) => {
    return {
        getFooter: () => dispatch(getFooter()),
    };
};

const mapStateToProps = (state) => {
    return {
        i18nLabels,
        footerDocument: Utility.getValues(state, 'headerFooter.footerDocument', '')
    };
};

class Footer extends Component {
    render() {
        return <FooterMainView {...this.props} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DecorateContainer(Footer));
